/** What the side panels and the playfield messages show for the session this frame (spec 08 §2). */

import { effectsLook } from '../../sim/items';
import type { Banner } from '../../ui/hud/messages';
import type { HudState } from '../../ui/hud/panels';
import { banners } from './banners';
import type { Session } from './session';

export function hudState(s: Session): HudState {
  const w = s.world;
  const panel = (i: 0 | 1) => {
    const p = w?.players[i];
    return {
      playing: p !== undefined && (p.state === 'play' || p.state === 'dying'),
      score: (p?.score ?? 0) * 10,
      lives: p?.lives ?? 0,
      extend: p?.extend ?? [false, false, false, false, false, false],
    };
  };
  // After the ending the title's round reads ALL, as the C64's did; the secret room has no number.
  const round = s.completed && !w ? 'ALL' : w?.level.n === 0 ? '?' : w?.level.n ?? s.startLevel;
  return { level: round, hiScore: s.hi.value * 10, players: [panel(0), panel(1)], hidden: s.mode === 'story' };
}

/** The messages in the playfield this frame; none while a menu covers it. */
export function sessionBanners(s: Session, steady: boolean, covered: boolean): Banner[] {
  if (covered) return [];
  const fx = s.world && s.mode === 'play' ? effectsLook(s.world) : null;
  return banners({
    mode: s.mode, paused: s.paused, world: s.world, timer: s.timer, hurryShown: s.hurryShown,
    extendPlayer: s.extendPlayer, suporr: s.suporr, bonusSeconds: fx?.bonusSeconds ?? -1, bonus: fx?.bonus ?? null,
    steady,
  });
}
